






















































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ZenObjectTable, ZenEllipsis } from 'zenComponents';
import ZenButton from '@reciprocity/button';
import { VBTooltip, BDropdownItemButton, BDropdownDivider } from 'bootstrap-vue';
import { Score, RiskAddEditMode } from './types';
import EditColumn from '@/components/zen_components/zen_object_table/edit_column/EditColumn.vue';
import RowActions from '@/components/zen_components/zen_object_table/row_actions/RowActions.vue';
import { ScoreEditType } from './editTypes';
import { ScoreAddType } from './addTypes';

export default Vue.extend({
  name: 'ScoresTab',
  components: {
    ZenObjectTable,
    ZenEllipsis,
    EditColumn,
    ZenButton,
    RowActions,
    BDropdownItemButton,
    BDropdownDivider,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  data() {
    return {
      data: <Score[]>[],
      loading: <boolean>true,
    };
  },
  computed: {
    ...mapGetters(['routes', 'featureFlags']),
    columns() {
      const columns = [
        'title',
        { label: 'Score Calculation', key: 'formula' },
        { label: 'Score Threshold Ranges', key: 'thresholds' },
        'actions',
      ];
      return columns;
    },
  },
  async created() {
    this.fetchScores();
  },
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
      showModal: 'modals/show',
      request: 'request',
    }),
    async fetchScores() {
      try {
        this.data = await this.request({
          route: 'riskScores',
          defaultErrorHandler: false,
        });
      } catch (e) {
        this.showAlert({
          type: 'error',
          message: 'Failed to load Risk Scores',
        });
      } finally {
        this.loading = false;
        this.$emit('loaded');
      }
    },
    async edit(score: Score, editTypeName: string) {
      try {
        await this.showModal({
          type: 'RiskEditCard',
          data: this.getEditCardData(score, editTypeName),
        });
        if (editTypeName === 'title') {
          this.$emit('refreshTabs', ['heatmap']);
        }
        this.fetchScores();
      } catch (e) {
        // User closed modal
      }
    },
    getEditCardData(score: Score, editTypeName: string) {
      const url = `${this.routes.riskScores}/${score.id}`;
      const calculationUrl = this.routes.riskFormula.replace('__OBJECT_ID__', score.id);
      return {
        url: editTypeName === 'calculation' ? calculationUrl : url,
        saveUrl: url,
        required: true,
        ...ScoreEditType[editTypeName],
      };
    },
    async deleteScore(score: Score) {
      try {
        await this.showModal({
          type: 'RiskDeleteCard',
          data: {
            url: `${this.routes.riskScores}/${score.id}`,
            title: score.title,
            riskElement: 'Score',
            successMessage: 'Score deleted successfully',
          },
        });
        this.$emit('refreshTabs', ['heatmap']);
        this.fetchScores();
      } catch (e) {
        // User closed modal
      }
    },
    thresholdClasses(color: string) {
      const isWhite = color === '#FFFFFF';
      return {
        'fa mr-1': true,
        'fa-circle': !isWhite,
        'fa-circle-o': isWhite,
      };
    },
    thresholdColor(color: string) {
      const isWhite = color === '#FFFFFF';
      return isWhite ? '#ced4da' : color;
    },
    async duplicateOrEditScore(score: Score, duplicate: Boolean) {
      try {
        await this.showModal({
          type: 'RiskAddEditCard',
          data: {
            dataUrl: this.routes.riskFormula.replace('__OBJECT_ID__', score.id),
            valuesUrl: `${this.routes.riskScores}/${score.id}`,
            saveUrl: this.routes.riskScores + (duplicate ? '' : `/${score.id}`),
            objType: 'Score',
            fields: ScoreAddType,
            modalSize: 'Medium',
            mode: duplicate ? RiskAddEditMode.Duplicate : RiskAddEditMode.Edit,
            successMessage: duplicate ? 'New Score added successfully' : 'Score updated successfully',
            title: `${duplicate ? 'Duplicate' : 'Edit'} Score`,
          },
        });
        this.$emit('refreshTabs', ['heatmap']);
        this.fetchScores();
      } catch (e) {
        // User closed modal
      }
    },
    async add() {
      try {
        await this.showModal({
          type: 'RiskAddEditCard',
          data: {
            dataUrl: this.routes.riskFormulaElements.replace('__OBJECT_TYPE__', 'score'),
            saveUrl: this.routes.riskScores,
            objType: 'Score',
            fields: ScoreAddType,
            modalSize: 'Medium',
            successMessage: 'New Score added successfully',
            title: 'Add new Score',
          },
        });
        this.fetchScores();
      } catch (e) {
        // User closed modal
      }
    },
  },
});
